export default {
  'blog.eyebrow': 'Vietnam Story',
  'blog.title': 'Travel Guides',
  'blog.subtitle': 'Honest costs, real routes, and the people who plan them. Written by the local experts who run these trips every week.',
  'blog.home': 'Home',
  'blog.blog': 'Blog',
  'blog.searchPlaceholder': 'Search guides',
  'blog.searchAria': 'Search blog posts',
  'blog.loading': 'Loading guides...',
  'blog.loadFailed': 'Could not load guides.',
  'blog.tryAgain': 'Try again',
  'blog.latest': 'Latest guides',
  'blog.noGuides': 'No guides found. Try a different search.',
  'blog.pagination': 'Pagination',
  'blog.goToPage': 'Go to page {{page}}',
  'blog.ctaTitle': 'Need a custom itinerary?',
  'blog.ctaText': 'Tell a local expert what you have in mind. They will send back a route built for your dates, pace and budget, not a template.',
  'blog.contactExpert': 'Contact a local expert',
  'blog.newsTitle': 'Still deciding on the route?',
  'blog.newsText': 'Subscribe for travel guides, local tips, and honest Vietnam advice delivered to your inbox. No spam, ever.',
  'blog.emailPlaceholder': 'Enter your email',
  'blog.subscribe': 'Subscribe',
  'blog.subscribing': 'Subscribing...',
  'blog.thanks': 'Thanks for subscribing! Check your inbox for travel tips.',
  'blog.invalidEmail': 'Please enter a valid email address.',
  'blog.errorGeneric': 'Something went wrong. Please try again.',
  'blog.errorNetwork': 'Network error. Please try again.',
  'blog.breadcrumb': 'Breadcrumb',
  'blog.tableOfContents': 'Table of contents',
  'blog.faq': 'Frequently Asked Questions',
  'blog.loadingArticle': 'Loading article...',
  'blog.couldNotLoadArticle': 'Could not load this article',
  'blog.articleNotFound': 'Article not found',
  'blog.articleNotFoundText': 'The blog post you are looking for does not exist.',
  'blog.by': 'By',
  'blog.sidebarTitle': 'Explore Vietnam, worry-free',
  'blog.sidebarText': 'Honest guides, real routes, and local experts who plan them. Written by the people who run these trips every week.',
  'blog.exploreTours': 'Explore our tours',
  'blog.share': 'Share',
  'blog.copyLink': 'Copy link',
  'blog.shareFacebook': 'Share on Facebook',
  'blog.shareWhatsApp': 'Share on WhatsApp',
  'blog.heroAlt': 'Vietnam Story - Travel Guides',
  'blog.captchaRequired': 'Please confirm you are not a robot.',
  'blog.captchaFailed': 'Security verification failed. Please try again.',
};